/* eslint-disable @typescript-eslint/ban-types */
import { MenuItem } from '@material-ui/core'
import React from 'react'
import {
  renderHelpersText,
  renderErrorInField,
  renderUpdatedInField,
} from '@flatsy/utils/Functions/form/Helpers'
import { FieldsType, SelectType, SingleFieldProps } from '../../../../Types'
import FormTextField from '../../../../../Global/TextField'

const SelectField = <T extends {}>({
  field,
  input,
  meta,
  values,
  justSubmitted,
}: SingleFieldProps<T>): React.ReactElement => {
  /**
   * @description render label or condition label
   * @param field
   * @param values
   */
  const renderLabelInField = (field: FieldsType, values: T) => {
    return field.conditional ? field.conditional(values).label : field.label
  }

  /**
   * @description format field value
   * @param val
   */
  const onChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (field.changeEvent) {
      field.changeEvent(val.target.value)
    }
    input.onChange(val.target.value)
  }

  /**
   * @description render an array of react element
   * @param options
   */
  const renderOptions = (options: SelectType[] | undefined) => {
    if (options) {
      return options.map((select) => (
        <MenuItem key={select.value} value={select.value}>
          {select.label}
        </MenuItem>
      ))
    }
    return <div />
  }

  return (
    <FormTextField
      error={renderErrorInField(meta)}
      updated={renderUpdatedInField(meta, justSubmitted)}
      helperText={renderHelpersText(field, meta.touched, meta.error, meta.submitError)}
      label={renderLabelInField(field, values)}
      className={field.className || undefined}
      disabled={field.disabled}
      {...input}
      fullWidth
      select
      onChange={onChange}
      testid="form-field-select"
    >
      {renderOptions(field.selectValue)}
    </FormTextField>
  )
}

export default SelectField
